"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = config;

var _env = _interopRequireDefault(require("./env.dev"));

var _env2 = _interopRequireDefault(require("./env.stage"));

var _env3 = _interopRequireDefault(require("./env.prod"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * Performs configuration loads.
 *
 * @param   {string}  env  One of 'dev','stage' or 'prod'
 *
 * @return  {json}       configuration
 */
function config(env) {
  switch (env) {
    case 'dev':
    default:
      return _env["default"];

    case 'stage':
      return _env2["default"];

    case 'prod':
      return _env3["default"];
  }
}